import { AxiosResponse } from 'axios';
import { Response6001CertificateVM } from 'front-office/view-models/response-certificate-vm';
import { Certificate } from 'shell/models/certification';
import { HttpResponse } from 'shell/models/http-response';

export const transform6001Response = (
  response: AxiosResponse<HttpResponse<Certificate>>
): Response6001CertificateVM => {
  return {
    certificate: response.data.payload?.risposta6001OK?.file.certificatoPdf,
    warnings: (response.data.payload?.risposta6001OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.risposta6001KO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
  };
};
